<mat-icon
    [svgIcon]="icon"
    [class]="'material-icons mat-icon' + className"
></mat-icon>
